import React, { useMemo, useState } from "react";
import { App, Button, Col, DatePicker, Form, Input, InputNumber, Modal, Row } from "antd";
import dayjs from "dayjs";
import { calculateKermesTotal } from "../utils/kermesPricing";
import { createKermesPreorder } from "../utils/api";
import { buildOrderItems } from "../utils";
import OrderTotals from "./OrderTotals";

const INITIAL_VALUES = { panuchos: 0, salbutes: 0, deposit: 0 };

export default function NewOrderModal({ open, onClose, onCreated, userId }) {
  const { message } = App.useApp();
  const [form] = Form.useForm();
  const [saving, setSaving] = useState(false);

  const panuchos = Form.useWatch("panuchos", form) || 0;
  const salbutes = Form.useWatch("salbutes", form) || 0;
  const deposit = Form.useWatch("deposit", form) || 0;

  const totalItems = Number(panuchos) + Number(salbutes);
  const total1 = useMemo(() => calculateKermesTotal(totalItems), [totalItems]);
  const total = useMemo(() => {
    const result = calculateKermesTotal(totalItems);

    console.log("TOTAL PEDIDO:", {
        panuchos,
        salbutes,
        totalItems,
        result
    });

    return result;
}, [totalItems, panuchos, salbutes]);
  const remaining = Math.max(0, total - Number(deposit));

  // Se reinicia el formulario cada vez que se abre, para no arrastrar
  // cantidades del pedido anterior.
  const handleAfterOpenChange = (isOpen) => {
    if (isOpen) {
      form.resetFields();
      form.setFieldsValue(INITIAL_VALUES);
    }
  };

  const handleSubmit = async (values) => {
    const items = buildOrderItems(values.panuchos, values.salbutes);
    const quantityTotal = items.reduce((sum, item) => sum + item.quantity, 0);

    if (quantityTotal <= 0) {
      message.warning("Agrega al menos una pieza.");
      return;
    }

    const calculatedTotal = calculateKermesTotal(quantityTotal);
    const calculatedDeposit = Number(values.deposit || 0);

    if (calculatedDeposit > calculatedTotal) {
      message.warning("El anticipo no puede ser mayor al total.");
      return;
    }

    setSaving(true);
    try {
      await createKermesPreorder({
        user_id: userId,
        customer_name: values.customer_name,
        customer_phone: values.customer_phone || null,
        delivery_date: values.delivery_date ? values.delivery_date.format("YYYY-MM-DD") : null,
        deposit: calculatedDeposit,
        items,
      });

      message.success("Pedido registrado y apartado del inventario.");
      onCreated();
    } catch (error) {
      message.error(error.message);
    } finally {
      setSaving(false);
    }
  };

  return (
    <Modal
      title="Nuevo pedido anticipado"
      open={open}
      onCancel={onClose}
      afterOpenChange={handleAfterOpenChange}
      footer={null}
      destroyOnClose
    >
      <Form form={form} layout="vertical" initialValues={INITIAL_VALUES} onFinish={handleSubmit}>
        <Row gutter={16}>
          <Col span={12}>
            <Form.Item
              label="Cliente"
              name="customer_name"
              rules={[{ required: true, message: "Ingresa el nombre del cliente." }]}
            >
              <Input placeholder="Nombre del cliente" />
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item label="Teléfono" name="customer_phone">
              <Input placeholder="Teléfono" />
            </Form.Item>
          </Col>
        </Row>

        <Form.Item label="Fecha de entrega" name="delivery_date">
          <DatePicker
            style={{ width: "100%" }}
            format="DD/MM/YYYY"
            disabledDate={(date) => date && date.isBefore(dayjs().startOf("day"))}
          />
        </Form.Item>

        <Row gutter={16}>
          <Col span={12}>
            <Form.Item label="Panuchos" name="panuchos" rules={[{ type: "number", min: 0 }]}>
              <InputNumber min={0} style={{ width: "100%" }} />
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item label="Salbutes" name="salbutes" rules={[{ type: "number", min: 0 }]}>
              <InputNumber min={0} style={{ width: "100%" }} />
            </Form.Item>
          </Col>
        </Row>

        <OrderTotals totalItems={totalItems} total={total} remaining={remaining} />

        <Form.Item
          label="Anticipo"
          name="deposit"
          rules={[{ type: "number", min: 0 }]}
          style={{ marginTop: 20 }}
        >
          <InputNumber min={0} max={total} precision={2} style={{ width: "100%" }} prefix="$" />
        </Form.Item>

        <Button type="primary" htmlType="submit" block loading={saving}>
          Registrar pedido
        </Button>
      </Form>
    </Modal>
  );
}
